export default __webpack_public_path__ + "static/logo-2a253822eec7c2577f51781d392f78b5.png";